import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon, Modal } from "semantic-ui-react";

import { useTypedMutation } from "hooks";
import "modules/LeadsDashboard/components/LeadsExportModal/LeadsExportModal.scss";

type Props = {
  open: boolean;
  onClose: () => void;
  onExport: () => Promise<void>;
};

export const LeadsExportModal = ({ open, onClose, onExport }: Props) => {
  const { t } = useTranslation();

  const { mutate, isPending, isSuccess, isError, reset } = useTypedMutation<void, void>({ mutationFn: onExport, onSuccess: () => null });

  useEffect(() => {
    if (open) mutate();
    else reset();
  }, [open]);

  return (
    <Modal size="tiny" open={open} onClose={onClose} className="LeadsExportModal">
      <Modal.Header>
        <div className="export-file-container">
          <div>
            <Icon className="file" />
            <span> {t("v8_export", "Export")} </span>
          </div>

          <Button basic icon onClick={onClose} className="export-modal-close-button">
            <div className="export-modal-close-button-container">
              <Icon className="xmark" size="big" />
            </div>
          </Button>
        </div>
      </Modal.Header>
      <Modal.Actions>
        <div className="export-modal-content-text">
          {isPending && `${t("v8_loading", "Loading")}...`}
          {isSuccess && t("v8_export_queued", "Export queued for download. You will receive a notification when ready.")}
          {isError && t("v8_something_went_wrong", "Something went wrong, please contact the administrator")}
        </div>
      </Modal.Actions>
    </Modal>
  );
};
